import { Component, ElementRef, EventEmitter, HostListener, Output, ViewChild, Input, OnChanges, SimpleChanges} from '@angular/core';

@Component({
  selector: 'app-signature-pad',
  templateUrl: './signature-pad.component.html',
  styleUrls: ['./signature-pad.component.scss']
})

export class SignaturePadComponent implements OnChanges {
  @ViewChild('signPad', {static: false}) signPad!: ElementRef<HTMLCanvasElement>;
  @Output() signatureSave = new EventEmitter();
  @Output() sendImageValidation = new EventEmitter();
  @Input() CurrentSignature; @Input() textContent;
  signatureImg?: string;
  signPadElement: any;
  context: any;
  isDrawing: boolean;
  showCanvasLabel: boolean = true;
  showCanvas: boolean = true;

  public ngAfterViewInit(): void {
    if(this.signPad.nativeElement) {
      this.setCanvas();
    }
  }

  setCanvas() {
    this.signPadElement = this.signPad.nativeElement;
    this.signPadElement.style.width = "100%";
    this.signPadElement.width = this.signPadElement.offsetWidth;
    this.signPadElement.style.height = "200";
    this.signPadElement.height = this.signPadElement.offsetHeight;
    this.context = this.signPadElement.getContext('2d');
    this.context.strokeStyle = "#222222";
  }

  private relativeCoords(event: any): { x: number, y: number} {
    const bounds = event.target.getBoundingClientRect();
    const coords = {
      clientX: event.clientX || event.changedTouches[0].clientX,
      clientY: event.clientY || event.changedTouches[0].clientY
    }
    const x = coords.clientX - bounds.left;
    const y = coords.clientY - bounds.top;
    return {x, y}
  }

  onMouseDown(e: any): void {
    this.isDrawing = true;
    this.showCanvasLabel = false;
    const coords = this.relativeCoords(e);    
    this.context.moveTo(coords.x, coords.y);
    this.sendImageValidation.emit(false);
  }

  @HostListener('document:mouseup', ['$event'])
    onMouseUp(e: any): void {
      this.isDrawing = false;
    }

  onMouseMove(e: any): void {
    if (this.isDrawing) {
      const coords = this.relativeCoords(e);
      this.context.lineTo(coords.x, coords.y);
      this.context.stroke();
    }
  }

  clearSignature() {
    this.signatureImg = undefined;
    if (this.CurrentSignature) {
      this.signatureSave.emit(this.signatureImg);
    }
    this.showCanvasLabel = true;
    setTimeout(() => {
      this.setCanvas();
      this.context.clearRect(0, 0, this.signPadElement.width, this.signPadElement.height);
      this.context.beginPath();
    }, 100);
    this.sendImageValidation.emit(true);
  }

  saveSignature() {
    this.signatureImg = this.signPadElement.toDataURL('img/jpg');
    this.signatureSave.emit(this.signatureImg)
  }

  ngOnChanges(changes: SimpleChanges) {
    if(this.CurrentSignature) {
      this.showCanvas = false;
      this.showCanvasLabel = false;
    } else {
      this.showCanvas = true;
      this.showCanvasLabel = true;
    }
  }
}
